export default __webpack_public_path__ + "static/media/failure-tick.3f92b96c.svg";